// src/utils/pdfGenerator.js
import jsPDF from "jspdf";
import "jspdf-autotable";

const generatePDFReport = (employees, selectedDepartment) => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(18);
  doc.text("Employee Performance Report", 14, 22);

  // Divider line
  doc.setLineWidth(0.5);
  doc.setDrawColor(192, 192, 192);
  doc.line(14, 28, 200, 28);

  // Header Info
  doc.setFontSize(12);
  doc.text("Employee: All - All employees selected", 14, 35);

  const formattedDate = new Date().toLocaleDateString();
  doc.text(`Report Date: ${formattedDate}`, 14, 42);
  doc.text("Exceptions: No Deletions", 14, 49);
  doc.text(`Department: ${selectedDepartment}`, 14, 56);

  // Table Headers
  const headers = [
    [
      "Employee ID",
      "Employee Name",
      "Manager",
      "Evaluated Period",
      "Performance Score",
      "Rating",
    ],
  ];

  // Table Data - Updated to match the new API structure
  const data = employees.map((employee) => {
    // Use revieweeId instead of employeeId
    const employeeId = employee.revieweeId ?? "N/A";
    
    // Use revieweeName directly instead of combining firstName and lastName
    const employeeName = employee.revieweeName ?? "N/A";
    
    // Use reviewerName directly instead of combining supervisorFirstName and supervisorLastName
    const manager = employee.reviewerName ?? "N/A";

    // Use periodStart and periodEnd directly from the employee object
    const evaluatedPeriod =
      employee.periodStart && employee.periodEnd
        ? `${new Date(employee.periodStart).toLocaleDateString()} - ${new Date(
            employee.periodEnd
          ).toLocaleDateString()}`
        : "N/A";

    // Use totalPerformanceScore directly from the employee object
    const performanceScore = 
      typeof employee.totalPerformanceScore === "number" 
        ? employee.totalPerformanceScore.toFixed(1) 
        : "N/A";

    // Use performanceRatingName or performanceRatingCode directly from the employee object
    const rating = employee.performanceRatingName || employee.performanceRatingCode || "N/A";

    return [
      employeeId,
      employeeName,
      manager,
      evaluatedPeriod,
      performanceScore,
      rating,
    ];
  });

  // Table
  // Table
doc.autoTable({
  startY: 62,
  head: headers,
  body: data,
  headStyles: {
    fillColor: [192, 192, 192],
    fontSize: 8,
    halign: "center",  // Center header text
    valign: "middle",
  },
  bodyStyles: {
    halign: "center",  // Center all body cells
    valign: "middle",
  },
  alternateRowStyles: {
    fillColor: [245, 245, 245],
    halign: "center", // Center alternate rows too
  },
  styles: {
    fontSize: 8,
    cellPadding: 3,
  },
  margin: { left: 14, right: 14 },
});

  // Save
  doc.save(`employee_performance_report_${selectedDepartment}.pdf`);
};

export default generatePDFReport;